import AppRoute from "models/AppRoute"

const UserSettingsRoute = new AppRoute({
    route: "/user",
    navbar: true,
    authRequired: true,
})

export default UserSettingsRoute
